import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { FeatureFlagFragmentDoc } from '../fragments/generated/FeatureFlag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FeatureFlagsQueryVariables = Types.Exact<{
  input: Types.FeatureFlagsInput;
}>;


export type FeatureFlagsQuery = { featureFlags: { featureFlags: Array<{ name: string, value: string, type: Types.FlagValueTypeEnum }> } };


export const FeatureFlagsDocument = /*#__PURE__*/ gql`
    query featureFlags($input: FeatureFlagsInput!) {
  featureFlags(input: $input) {
    featureFlags {
      ...FeatureFlag
    }
  }
}
    ${FeatureFlagFragmentDoc}`;

export function useFeatureFlagsQuery(options: Omit<Urql.UseQueryArgs<FeatureFlagsQueryVariables>, 'query'>) {
  return Urql.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>({ query: FeatureFlagsDocument, ...options });
};